export class ReportErrorsModel {
    emptyReportName: boolean;

    constructor() {
        this.emptyReportName = false;
    }
}
